<template>
  <v-select
    :label="displayText"
    :items="businessRolesList"
    v-model="businessRolesValue"
    :multiple="multiple"
    :chips="multiple"
    item-text="label"
    item-value="name"
    :readonly="readonly"
    :rules="[required(displayText)]"
    outlined
  ></v-select>
</template>

<script>
import { businessRolesList } from '@/lib/constants/securityRoles'
import { required } from '@/lib/formValidations'
export default {
  props: [
    'businessRoles',
    'multiple',
    'readonly'
  ],
  data () {
    return {
      businessRolesList
    }
  },
  computed: {
    displayText () {
      return this.multiple ? 'Roles' : 'Role'
    },
    businessRolesValue: {
      get () {
        return this.businessRoles
      },
      set (newValue) {
        this.$emit('businessRolesChange', newValue)
      }
    }
  },
  methods: {
    required
  }
}
</script>
